<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Incidents from './incidents'

import axios from 'axios'

export default {
	page: {
		title: 'Resolved Other Incidents',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Incidents },
	data() {
		return {
			title: 'Resolved Other Incidents',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Resolved Other Incidents',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Incidents :url="'/pan/xdr/incidents?include=incident.incident,incident.assets&status=resolved_other'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
